<template>
  <div class="space-y-2 prose dark:prose-invert">
    <p>We retain your email address only while your account is active.</p>
    <p>If you delete your account or request removal, your email and associated data will be permanently deleted from our systems.</p>
  </div>
</template>